/**
 * Maps each custom icon name to a loader that dynamically imports its SVG component, so every
 * custom icon lives in its own code-split chunk and is only fetched when actually rendered.
 *
 * Each loader resolves the module's named export into the `{default}` shape that `React.lazy`
 * expects, which keeps the icon modules free of default exports.
 *
 * To add one: add its name to `CustomIconName`, create its module under `custom-icons/`, and add a
 * loader entry here, e.g.
 * `'my-icon': () => import('./custom-icons/my-icon').then(module => ({default: module.MyIcon})),`
 */
export const CUSTOM_ICON_LOADERS = {
    'activity-nap': () => import('./custom-icons/activity-nap').then(module => ({ default: module.ActivityNapIcon })),
    'activity-diaper-toilet': () => import('./custom-icons/activity-diaper-toilet').then(module => ({
        default: module.ActivityDiaperToiletIcon,
    })),
    'activity-meal': () => import('./custom-icons/activity-meal').then(module => ({ default: module.ActivityMealIcon })),
    'activity-check-out': () => import('./custom-icons/activity-check-out').then(module => ({
        default: module.ActivityCheckOutIcon,
    })),
    'activity-note': () => import('./custom-icons/activity-note').then(module => ({ default: module.ActivityNoteIcon })),
    'activity-medication': () => import('./custom-icons/activity-medication').then(module => ({
        default: module.ActivityMedicationIcon,
    })),
};
const CUSTOM_ICON_NAMES = new Set(Object.keys(CUSTOM_ICON_LOADERS));
/**
 * Type guard that tells whether a given icon name refers to a custom SVG icon (as opposed to a
 * Material Symbols font icon). Used by consumers to decide how to render the icon.
 *
 * @param name - The icon name to check.
 * @returns `true` when the name is a registered custom icon.
 */
export const isCustomIconName = (name) => CUSTOM_ICON_NAMES.has(name);
